import Modal from "@component/modal";
import Autocomplete from "@component/autocomplete";
import { navbar } from "@component/navbar";
import vacationSlider from "@component/vacationSlider";
import partnersSlider from "@component/partnersSlider";
import projectsSlider from "@component/projectsSlider";
import clientSlider from "@component/clientSlider";
import testimonials from "@component/testimonials";
import process from "@component/process";
import related from "@component/related";
import sliderBlock from "@component/sliderBlock";
import loadMore from "@component/loadMore";
import production from "@component/production";
import parallax from "@component/parallax";
import GoogleMap from "@component/googleMap";
import popup from "@component/popup";
// import loading from "@component/loading";

export default () => {
    Autocomplete();
    new Modal();
    navbar();
    vacationSlider();
    partnersSlider();
    projectsSlider();
    clientSlider();
    testimonials();
    process();
    related();
    sliderBlock();
    loadMore();
    production();
    parallax();
    new GoogleMap();
    popup();
    // loading();
};
